import React from "react";
import { Box, Image, Text } from "@chakra-ui/react";
import { LEAD_PRO_LOGO, NURTUR_LOGO } from "constants/image-paths";

const Logo = () => {
  const logoColour = "#272C33";

  return (
    <Box display={"flex"} mt={5} color={logoColour}>
      <Image
        height={"34px"}
        objectFit="cover"
        alt={"nurtur-logo"}
        src={NURTUR_LOGO}
        mr={4}
      />
      <Box>
        <Text
          fontFamily={"nurtur"}
          fontWeight={600}
          fontSize={"22px"}
          lineHeight={"100%"}
        >
          Nurtur
        </Text>
        <Text
          fontFamily={"inter"}
          fontWeight={300}
          fontSize={"sm"}
          lineHeight={"100%"}
        >
          Lead Management
        </Text>

        <Box display={"flex"} alignItems={"center"} opacity={0.8}>
          <Text
            fontFamily={"inter"}
            fontWeight={300}
            fontSize={"10px"}
            lineHeight={"16px"}
            display={"inline"}
          >
            Powered by
          </Text>
          <Image
            height={"12px"}
            objectFit="cover"
            alt={"leadpro-logo"}
            src={LEAD_PRO_LOGO}
            display={"inline"}
            px={1}
          />
          <Text
            fontFamily={"inter"}
            fontWeight={400}
            fontSize={"10px"}
            lineHeight={"16px"}
            display={"inline"}
          >
            Leadpro
          </Text>
        </Box>
      </Box>
    </Box>
  );
};

export default Logo;
